(() => {
  const qs = (s, c=document) => c.querySelector(s);
  const qsa = (s, c=document) => [...c.querySelectorAll(s)];

  document.documentElement.classList.remove('no-js');

  const lock = () => document.body.classList.add('is-locked');
  const unlock = () => document.body.classList.remove('is-locked');

  const mobileMenu = qs('[data-mobile-menu]');
  qsa('[data-mobile-menu-open]').forEach(btn => btn.addEventListener('click', () => {
    mobileMenu?.classList.add('is-open');
    mobileMenu?.setAttribute('aria-hidden','false');
    lock();
  }));
  qsa('[data-mobile-menu-close]').forEach(btn => btn.addEventListener('click', () => {
    mobileMenu?.classList.remove('is-open');
    mobileMenu?.setAttribute('aria-hidden','true');
    unlock();
  }));

  const searchPanel = qs('[data-search-panel]');
  qsa('[data-search-toggle]').forEach(btn => btn.addEventListener('click', () => {
    if (!searchPanel) return;
    searchPanel.hidden = !searchPanel.hidden;
    if (!searchPanel.hidden) setTimeout(() => qs('input', searchPanel)?.focus(), 30);
  }));

  qsa('[data-tabs-section]').forEach(section => {
    const buttons = qsa('[data-tab-target]', section);
    const panels = qsa('[data-tab-panel]', section);
    buttons.forEach(button => button.addEventListener('click', () => {
      const target = button.dataset.tabTarget;
      buttons.forEach(b => b.classList.toggle('is-active', b === button));
      panels.forEach(p => {
        const active = p.dataset.tabPanel === target;
        p.hidden = !active;
        p.classList.toggle('is-active', active);
      });
    }));
  });

  const filterDrawer = qs('[data-filter-drawer]');
  qsa('[data-filter-toggle]').forEach(btn => btn.addEventListener('click', () => {
    if (!filterDrawer) return;
    filterDrawer.classList.toggle('is-open');
    filterDrawer.setAttribute('aria-hidden', filterDrawer.classList.contains('is-open') ? 'false' : 'true');
    document.body.classList.toggle('is-locked', filterDrawer.classList.contains('is-open'));
  }));

  const formatMoney = cents => {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-NL', {style:'currency', currency: window.Shopify?.currency?.active || 'EUR'}).format(cents/100);
    } catch(e) {
      return `€${(cents/100).toFixed(2)}`;
    }
  };

  // Unified Shopify AJAX cart. Keeps the real cart, checkout, and market currency in sync.
  const cartDrawer = qs('#CartDrawer');
  const cartBody = qs('[data-cart-drawer-body]');
  const cartFooter = qs('[data-cart-drawer-footer]');
  const cartTotal = qs('[data-cart-total]');
  const cartRoot = () => window.Shopify?.routes?.root || '/';
  const cartEscape = str => String(str ?? '').replace(/[&<>"']/g, c => ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'}[c]));
  const isDutch = () => document.documentElement.lang.toLowerCase().startsWith('nl');
  let cartChanging = false;
  let lastCartOpener = null;

  /* AMESHI Luxe T-shirt 2-for-79 selector; discount is applied by Shopify checkout. */
  const teeDealProducts=(()=>{
    try {return JSON.parse(document.getElementById('AmeshiTshirtDealProducts')?.textContent||'[]');}
    catch(e){return [];}
  })();
  const teeDealIds=new Set(teeDealProducts.map(p=>String(p.id)));
  const teeDealQuantity=cart => (cart.items||[]).reduce((n,i)=>n+(teeDealIds.has(String(i.product_id))?i.quantity:0),0);
  const teeDealCards=()=>{
    return '<div class="ameshi-tee-offer__photos" role="radiogroup" aria-label="Kies je tweede T-shirt">'+
      teeDealProducts.map((p,i)=>'<label class="ameshi-tee-offer__photo">'+
        '<input type="radio" name="ameshi-tee-photo" value="'+i+'" '+(i===0?'checked':'')+'>'+
        '<span class="ameshi-tee-offer__photo-frame">'+
          (p.image?'<img loading="lazy" alt="'+cartEscape(p.title)+'" src="'+cartEscape(p.image)+'">':'')+
        '</span><span class="ameshi-tee-offer__photo-name">'+cartEscape(p.title.replace(/LUXE T-SHIRT\s*\|\s*/i,''))+'</span>'+
      '</label>').join('')+'</div>';
  };
  const teeDealSizes=productIndex=>{
    const product=teeDealProducts[productIndex]||teeDealProducts[0];
    return '<label for="AmeshiTeeSize">Kies je maat</label><select id="AmeshiTeeSize" data-tee-offer-select>'+
      (product?.variants||[]).filter(v=>v.available).map(v=>
        '<option value="'+v.id+'">'+cartEscape(v.title)+'</option>'
      ).join('')+'</select>';
  };
  const teeDealHtml=cart=>{
    if(!teeDealProducts.length || teeDealQuantity(cart)!==1)return '';
    return '<div class="ameshi-tee-offer" data-tee-offer>'+
      '<span class="ameshi-tee-offer__label">EXCLUSIEVE DEAL</span>'+
      '<strong>2 T-SHIRTS VOOR €69</strong>'+
      '<p><s>€99,98</s> <b>€69,00</b> · <span class="ameshi-tee-offer__saving">JE BESPAART €30,98</span></p>'+
      '<p>Kies hieronder je tweede T-shirt en selecteer de maat.</p>'+
      teeDealCards()+'<div data-tee-offer-sizes>'+teeDealSizes(0)+'</div>'+
      '<button type="button" data-tee-offer-add>VOEG TWEEDE T-SHIRT TOE →</button>'+
      '<span class="ameshi-tee-offer__error" data-tee-offer-error role="alert"></span></div>';
  };
  document.addEventListener('change',event=>{
    if(!event.target.matches('[name="ameshi-tee-photo"]'))return;
    const panel=event.target.closest('[data-tee-offer]');
    const target=panel?.querySelector('[data-tee-offer-sizes]');
    if(target)target.innerHTML=teeDealSizes(Number(event.target.value));
  });
  document.addEventListener('click',async event=>{
    const btn=event.target.closest('[data-tee-offer-add]');
    if(!btn)return;
    const panel=btn.closest('[data-tee-offer]');
    const id=Number(panel?.querySelector('[data-tee-offer-select]')?.value);
    if(!id)return;
    btn.disabled=true;
    const message=panel.querySelector('[data-tee-offer-error]');
    if(message)message.textContent='';
    try{
      const res=await fetch(cartRoot()+'cart/add.js',{method:'POST',credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({id,quantity:1})});
      if(!res.ok){const d=await res.json().catch(()=>({}));throw new Error(d.description||'Toevoegen mislukt');}
      if(cartDrawer?.classList.contains('is-open'))await renderCart();
      else window.location.reload();
    }catch(e){if(message)message.textContent=e.message;btn.disabled=false;}
  });


  async function getCart(){
    const response = await fetch(cartRoot() + 'cart.js', {headers:{Accept:'application/json'},credentials:'same-origin'});
    if (!response.ok) throw new Error(isDutch() ? 'Winkelwagen laden mislukt.' : 'Unable to load your cart.');
    return response.json();
  }

  async function changeCart(line,quantity) {
    if (cartChanging) return;
    cartChanging = true;
    if (cartBody) cartBody.setAttribute('aria-busy','true');
    try {
      const response = await fetch(cartRoot() + 'cart/change.js', {
        method:'POST',
        credentials:'same-origin',
        headers:{'Content-Type':'application/json','Accept':'application/json'},
        body:JSON.stringify({line,quantity})
      });
      if (!response.ok) {
        const data = await response.json().catch(() => ({}));
        throw new Error(data.description || (isDutch() ? 'Winkelwagen wijzigen mislukt.' : 'Unable to update cart.'));
      }
      await renderCart();
    } catch(error) {
      const alertBox = qs('[data-cart-error]',cartDrawer);
      if (alertBox) alertBox.textContent = error.message;
    } finally {
      cartChanging = false;
      if(cartBody)cartBody.removeAttribute('aria-busy');
    }
  }

  async function renderCart(){
    if (!cartBody) return;
    const cart = await getCart();
    qsa('[data-cart-count]').forEach(el => el.textContent = cart.item_count > 99 ? '99+' : String(cart.item_count));

    const totalEl=qs('[data-cart-total]',cartDrawer);
    if (totalEl) totalEl.textContent=formatMoney(cart.total_price);
    if (!cart.items.length) {
      cartBody.innerHTML = `<div class="cart-drawer__empty" role="status">
        <svg viewBox="0 0 52 52" fill="none" aria-hidden="true"><path d="M13 18h26l-2 25H15l-2-25Z" stroke="currentColor" stroke-width="1.5"/><path d="M20 18v-4a6 6 0 0 1 12 0v4" stroke="currentColor" stroke-width="1.5"/></svg>
        <strong>${isDutch()?'Je winkelwagen is leeg':'Your shopping bag is empty'}</strong>
        <a class="text-link" href="${cartRoot()}collections/all">${isDutch()?'Verder winkelen':'Continue shopping'} →</a>
      </div>`;
      if (cartFooter) cartFooter.hidden=true;
      return;
    }
    cartBody.innerHTML = cart.items.map((item,i) => {
      const productUrl=cartEscape(item.url||'#');
      const img=item.image ? `<img loading="lazy" src="${cartEscape(item.image)}" alt="${cartEscape(item.product_title)}">` : '';
      return `<div class="drawer-line" data-cart-line="${i+1}">
        <a href="${productUrl}" aria-label="${cartEscape(item.product_title)}">${img}</a>
        <div class="drawer-line__meta">
          <strong><a href="${productUrl}">${cartEscape(item.product_title)}</a></strong>
          ${item.variant_title && item.variant_title !== 'Default Title' ? `<div class="drawer-line__variant">${cartEscape(item.variant_title)}</div>` : ''}
          <div class="drawer-line__price">${formatMoney(item.final_line_price)}</div>
          <div class="drawer-line__quantity" role="group" aria-label="Quantity">
            <button type="button" data-cart-quantity="-1" data-line="${i+1}" aria-label="Decrease quantity">−</button>
            <span>${item.quantity}</span>
            <button type="button" data-cart-quantity="1" data-line="${i+1}" aria-label="Increase quantity">+</button>
          </div>
        </div>
        <button class="drawer-line__remove" type="button" data-cart-remove="${i+1}" aria-label="Remove ${cartEscape(item.product_title)}">${isDutch()?'Verwijderen':'Remove'}</button>
      </div>`;
    }).join('') + teeDealHtml(cart);
    if(cartFooter)cartFooter.hidden=false;

    qsa('[data-cart-quantity]',cartBody).forEach(button => button.addEventListener('click',() => {
      const line=Number(button.dataset.line);
      const qty=Number(button.closest('.drawer-line')?.querySelector('.drawer-line__quantity span')?.textContent||1);
      const delta=Number(button.dataset.cartQuantity);
      changeCart(line,Math.max(0,qty+delta));
    }));
    qsa('[data-cart-remove]',cartBody).forEach(button => button.addEventListener('click',() => changeCart(Number(button.dataset.cartRemove),0)));
  }

  function openCart(){
    if (!cartDrawer) return;
    lastCartOpener = document.activeElement;
    cartDrawer.classList.add('is-open');
    cartDrawer.setAttribute('aria-hidden','false');
    lock();
    const errorBox=qs('[data-cart-error]',cartDrawer);
    if(errorBox)errorBox.textContent='';
    renderCart().catch(error => {
      if(errorBox)errorBox.textContent=error.message;
    });
    qs('[data-cart-close]:not(.cart-drawer__backdrop)',cartDrawer)?.focus();
  }

  function closeCart(){
    cartDrawer?.classList.remove('is-open');
    cartDrawer?.setAttribute('aria-hidden','true');
    unlock();
    if(lastCartOpener instanceof HTMLElement)lastCartOpener.focus();
  }

  qsa('[data-cart-open]').forEach(btn => btn.addEventListener('click',openCart));
  qsa('[data-cart-close]').forEach(btn => btn.addEventListener('click',closeCart));
  document.addEventListener('keydown',event => {
    if (event.key==='Escape'&&cartDrawer?.classList.contains('is-open'))closeCart();
  });
  document.addEventListener('ameshi:cart:updated',() => {
    renderCart().catch(() => {});
  });

  qsa('[data-product-root]').forEach(root => {
    const thumbs = qsa('[data-media-thumb]', root);
    const panels = qsa('[data-media-panel]', root);

    const setActiveThumb = id => {
      thumbs.forEach(t => t.classList.toggle('is-active', t.dataset.mediaThumb === String(id)));
    };

    thumbs.forEach(thumb => thumb.addEventListener('click', () => {
      const id = thumb.dataset.mediaThumb;
      const panel = panels.find(item => item.dataset.mediaPanel === id);
      if (!panel) return;
      setActiveThumb(id);
      const headerOffset = 96;
      const top = panel.getBoundingClientRect().top + window.scrollY - headerOffset;
      window.scrollTo({top, behavior:'smooth'});
    }));

    if ('IntersectionObserver' in window && panels.length) {
      const observer = new IntersectionObserver(entries => {
        const visible = entries
          .filter(entry => entry.isIntersecting)
          .sort((a,b) => b.intersectionRatio - a.intersectionRatio)[0];
        if (visible) setActiveThumb(visible.target.dataset.mediaPanel);
      }, {rootMargin:'-18% 0px -55% 0px', threshold:[0.05,0.2,0.5]});
      panels.forEach(panel => observer.observe(panel));
    }
  });

  qsa('[data-product-root]').forEach(root => {
    const variantsNode = qs('[data-product-variants]', root.parentElement || document) || qs('[data-product-variants]');
    const variants = variantsNode ? JSON.parse(variantsNode.textContent) : [];
    const hiddenId = qs('[data-variant-id]', root);
    const submit = qs('.product-submit', root);
    const price = qs('[data-product-price]', root);
    const radios = qsa('[data-option-index] input[type=\"radio\"]', root);
    const colorRadios = qsa('[data-color-selector]', root);
    const mediaPanels = qsa('[data-media-panel]', root);
    const mobileGallery = qs('[data-mobile-gallery]', root);

    function findVariant(){
      const selected = [];
      qsa('[data-option-index]', root).forEach(group => {
        const optionIndex = Number(group.dataset.optionIndex);
        selected[optionIndex] = qs('input:checked', group)?.value || '';
      });
      const variant = variants.find(v => v.options.every((value, index) => value === selected[index]));
      if (!variant) return;
      if (hiddenId) hiddenId.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      const priceWrap = qs('[data-product-price-wrap]', root);
      const isSale = Boolean(variant.compare_at_price && variant.compare_at_price > variant.price);
      priceWrap?.classList.toggle('is-on-sale', isSale);
      const old = qs('[data-original-price]', priceWrap);
      const savings = qs('[data-price-saving]', priceWrap);
      const previousColumn = qs('[data-previous-column]', priceWrap);
      const galleryTag = qs('[data-product-sale-tag]', root);
      if (old) old.textContent = isSale ? formatMoney(variant.compare_at_price) : '';
      if (previousColumn) previousColumn.hidden = !isSale;
      if (savings) {
        savings.hidden = !isSale;
        const percent = isSale ? Math.round((variant.compare_at_price - variant.price) / variant.compare_at_price * 100) : 0;
        savings.textContent = isSale ? 'Prijsverschil ' + percent + '%' : '';
      }
      if (galleryTag) galleryTag.hidden = !isSale;
      if (submit) {
        submit.disabled = !variant.available;
        const submitLabel = qs('[data-submit-label]', submit);
        if (submitLabel) submitLabel.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
        else submit.textContent = variant.available ? 'ADD TO CART' : 'SOLD OUT';
      }
      if (history.replaceState) {
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url.toString());
      }
    }
    const focusColorMedia = radio => {
      const mediaId = radio?.dataset?.mediaId;
      if (!mediaId) return;
      const panel = mediaPanels.find(item => item.dataset.mediaPanel === String(mediaId));
      if (!panel) return;

      qsa('[data-media-thumb]', root).forEach(thumb => {
        thumb.classList.toggle('is-active', thumb.dataset.mediaThumb === String(mediaId));
      });

      if (window.matchMedia('(max-width: 989px)').matches && mobileGallery) {
        mobileGallery.scrollTo({left: panel.offsetLeft, behavior:'smooth'});
      } else {
        const headerOffset = 96;
        const top = panel.getBoundingClientRect().top + window.scrollY - headerOffset;
        window.scrollTo({top, behavior:'smooth'});
      }
    };

    radios.forEach(radio => radio.addEventListener('change', () => {
      findVariant();
      if (radio.matches('[data-color-selector]')) focusColorMedia(radio);
    }));

    const initiallyCheckedColor = colorRadios.find(radio => radio.checked);
    if (initiallyCheckedColor) initiallyCheckedColor.closest('.product-color-option')?.classList.add('is-current');
    colorRadios.forEach(radio => radio.addEventListener('change', () => {
      colorRadios.forEach(item => item.closest('.product-color-option')?.classList.toggle('is-current', item.checked));
    }));

    const form = qs('[data-product-form]', root);
    form?.addEventListener('submit', async e => {
      e.preventDefault();
      if (submit?.disabled) return;
      const fd = new FormData(form);
      try {
        submit.disabled = true;
        const r = await fetch('/cart/add.js', {method:'POST', body:fd, headers:{'Accept':'application/json'}});
        if (!r.ok) throw new Error('Could not add to cart');
        await renderCart();
        openCart();
      } catch(err) {
        alert(err.message);
      } finally {
        submit.disabled = false;
      }
    });
  });


  qsa('[data-product-root]').forEach(root => {
    const gallery = qs('[data-mobile-gallery]', root);
    const panels = qsa('[data-gallery-index]', root);
    const dots = qsa('[data-gallery-dot]', root);
    const current = qs('[data-gallery-current]', root);
    const prev = qs('[data-gallery-prev]', root);
    const next = qs('[data-gallery-next]', root);
    if (!gallery || panels.length < 2) return;

    let activeIndex = 0;
    let ticking = false;

    const goTo = (index, behavior='smooth') => {
      activeIndex = Math.max(0, Math.min(panels.length - 1, index));
      const panel = panels[activeIndex];
      gallery.scrollTo({left: panel.offsetLeft, behavior});
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === activeIndex));
      if (current) current.textContent = String(activeIndex + 1);
    };

    const updateFromScroll = () => {
      const center = gallery.scrollLeft + gallery.clientWidth / 2;
      let closest = 0;
      let closestDistance = Infinity;
      panels.forEach((panel, i) => {
        const panelCenter = panel.offsetLeft + panel.offsetWidth / 2;
        const distance = Math.abs(center - panelCenter);
        if (distance < closestDistance) {
          closest = i;
          closestDistance = distance;
        }
      });
      activeIndex = closest;
      dots.forEach((dot, i) => dot.classList.toggle('is-active', i === activeIndex));
      if (current) current.textContent = String(activeIndex + 1);
      ticking = false;
    };

    gallery.addEventListener('scroll', () => {
      if (!ticking) {
        ticking = true;
        requestAnimationFrame(updateFromScroll);
      }
    }, {passive:true});

    dots.forEach((dot, i) => dot.addEventListener('click', () => goTo(i)));
    prev?.addEventListener('click', () => goTo(activeIndex - 1));
    next?.addEventListener('click', () => goTo(activeIndex + 1));
  });

  qsa('[data-combine-products]').forEach(section => {
    const rail = qs('[data-combine-rail]', section);
    const prev = qs('[data-combine-prev]', section);
    const next = qs('[data-combine-next]', section);
    if (!rail) return;
    const amount = () => Math.max(260, rail.clientWidth * .78);
    prev?.addEventListener('click', () => rail.scrollBy({left:-amount(), behavior:'smooth'}));
    next?.addEventListener('click', () => rail.scrollBy({left:amount(), behavior:'smooth'}));
  });

  qsa('[data-cross-sell-select]').forEach(select => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const card = select.closest('.product-combine__card');
      const price = card ? qs('[data-cross-sell-price]', card) : null;
      const old = card ? qs('[data-cross-sell-old]', card) : null;
      const savings = card ? qs('[data-cross-sell-save]', card) : null;
      const priceAmount = Number(option?.dataset.price);
      const comparisonAmount = Number(option?.dataset.compare || 0);
      if (!Number.isFinite(priceAmount)) return;
      if (price) price.textContent = formatMoney(priceAmount);
      const discounted = comparisonAmount > priceAmount;
      if (price) price.classList.toggle('is-sale', discounted);
      if (old) {
        old.hidden = !discounted;
        old.textContent = discounted ? formatMoney(comparisonAmount) : '';
      }
      if (savings) {
        savings.hidden = !discounted;
        savings.textContent = discounted ? 'SAVE ' + formatMoney(comparisonAmount - priceAmount) : '';
      }
    });
  });

  qsa('[data-cross-sell-form]').forEach(form => {
    form.addEventListener('submit', async e => {
      e.preventDefault();
      const button = qs('button[type="submit"]', form);
      const original = button?.innerHTML;
      try {
        if (button) { button.disabled = true; button.setAttribute('aria-busy','true'); }
        const r = await fetch('/cart/add.js', {method:'POST', body:new FormData(form), headers:{'Accept':'application/json'}});
        if (!r.ok) throw new Error('Could not add to cart');
        await renderCart();
        openCart();
      } catch(err) {
        alert(err.message);
      } finally {
        if (button) { button.disabled = false; button.removeAttribute('aria-busy'); if (original) button.innerHTML = original; }
      }
    });
  });

  /* Full-cart remove buttons use Shopify Cart Ajax then refresh Liquid totals. */
  document.querySelectorAll('[data-cart-page-remove]').forEach(button=>{
    button.addEventListener('click',async()=>{
      if(button.disabled)return;
      button.disabled=true;
      const parent=button.closest('[data-cart-page-form]');
      const error=parent?.querySelector('[data-cart-page-error]');
      if(error)error.textContent='';
      try{
        const response=await fetch(cartRoot()+'cart/change.js',{
          method:'POST',credentials:'same-origin',
          headers:{'Content-Type':'application/json','Accept':'application/json'},
          body:JSON.stringify({line:Number(button.dataset.cartPageRemove),quantity:0})
        });
        if(!response.ok){
          const data=await response.json().catch(()=>({}));
          throw new Error(data.description||'Could not remove the item.');
        }
        location.reload();
      }catch(e){
        if(error)error.textContent=e.message;
        button.disabled=false;
      }
    });
  });

})();
